import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
} from "reactstrap";
import config from "../../config/config";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import withRouter from "../../components/Common/withRouter";

class CreateCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Categories", link: "/categories" },
        { title: "Create Category", link: "#" },
      ],
      categoryName: "",
      categoryImage: null,
      imagePreview: null,
      categoryType: "Domestic", // default value
    };
  }


  handleInputChange = (e) => {
    this.setState({
      categoryName: e.target.value,
    });
  };

  handleTypeChange = (e) => {
    this.setState({
      categoryType: e.target.value,
    });
  };

  handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({
        categoryImage: file,
        imagePreview: URL.createObjectURL(file),
      });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('category_name', this.state.categoryName);
      formData.append('category_image', this.state.categoryImage);
      formData.append('category_type', this.state.categoryType);

      // Debug logs
      console.log('Sending category data:', {
        name: this.state.categoryName,
        image: this.state.categoryImage ? this.state.categoryImage.name : null,
        type: this.state.categoryType
      });

      const response = await fetch(`${config.API_BASE_URL}/categories`, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (response.ok) {
        console.log('Category created:', data);
        this.props.router.navigate("/categories");
      } else {
        console.error('Failed to create category:', data);
        alert(data.message || 'Failed to create category');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error creating category');
    }
  };

  handleCancel = () => {
    this.props.router.navigate("/categories");
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="Create Category"
              breadcrumbItems={this.state.breadcrumbItems}
            />
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                      <Row>
                        <Col md={4}>
                          <div className="mb-3">
                            <Label className="form-label">State / Country Name</Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter State / Country Name"
                              value={this.state.categoryName}
                              onChange={this.handleInputChange}
                              required
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="mb-3">
                            <Label className="form-label">Category Type</Label>
                            <Input
                              type="select"
                              className="form-control"
                              value={this.state.categoryType}
                              onChange={this.handleTypeChange}
                              required
                            >
                              <option value="Domestic">Domestic</option>
                              <option value="International">International</option>
                            </Input>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="mb-3">
                            <Label className="form-label">Category Image</Label>
                            <Input
                              type="file"
                              className="form-control"
                              onChange={this.handleImageChange}
                              accept="image/*"
                              required
                            />
                            {this.state.imagePreview && (
                              <img
                                src={this.state.imagePreview}
                                alt="Category Preview"
                                className="img-fluid mt-2"
                                style={{ maxHeight: "200px" }}
                              />
                            )}
                          </div>
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col className="d-flex justify-content-end">
                          <Button type="submit" color="primary" className="me-2">
                            Create Category
                          </Button>
                          <Button type="button" color="secondary" onClick={this.handleCancel}>
                            Cancel
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(CreateCategory);
